"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * Блок с отрицательными отступами для размещения колонок (``<Col />``) по горизонтали.
 * Блок нельзя вкладывать сам в себя, но можно чередовать далее по дереву с использованием ``Col``.
 * Стилизованный компонент, обладающий всеми свойствами ``div``.
 */
exports.Row = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    flex-wrap: wrap;\n\n    margin-left: calc(var(--plasma-grid-gutter) * -1);\n    margin-right: calc(var(--plasma-grid-gutter) * -1);\n"], ["\n    display: flex;\n    box-sizing: border-box;\n    flex-wrap: wrap;\n\n    margin-left: calc(var(--plasma-grid-gutter) * -1);\n    margin-right: calc(var(--plasma-grid-gutter) * -1);\n"])));
var templateObject_1;
//# sourceMappingURL=Row.js.map